import { graphql } from "api/cms-website/generated";

export const ReferralBannerFragment = graphql(/* GraphQL */ `
    fragment ReferralBannerFragment on ComponentComponentsReferralBanner {
        id
        noMarginBottom
        referralBannerTitle: title
        referralBannerSubtitle: subtitle
        referralBannerDescription: description
        referralBannerButtonText: buttonText
        referralBannerToastText: toastText
        referralBannerCards: cards {
            title
            text
            bgColor
            textColor
            image {
                url
                width
                height
                alternativeText
            }
        }
    }
`);
